import axios from 'axios';
import { select, call } from 'redux-saga/effects';
import { compose, pick, assoc, propEq, ifElse } from 'ramda';

import * as urls from 'constants/urls';
import { setFilter } from 'helpers/filterHelpers';
import { defaultApprovalListFilters } from 'constants/defaultFilters';

const getFilters = ({ status }, getParams) => status ? (
    getParams({
        filters: setFilter(status, defaultApprovalListFilters),
    })
) : {};

const getTableParams = tableState => ({
    ...pick(['line', 'linesPerPage'], tableState.pagination || {}),
    ...tableState.filters,
    ...tableState.sort
});

const isExcluded = propEq('stage', 'excluded');

const createTableHandler = (tableStateName, url, getParams = getTableParams) => {
    return function* fetchTable({ payload, params }) {
        const data = payload || params;
        const tableParams = yield select(store => getParams(store.table[tableStateName], data));
        const filters = data && getFilters(data, getParams);

        return yield call(axios.get, url.stringify(data), { params: { ...tableParams, ...filters }});
    };
};

const getWorksheetMassListParams = (tableState, data = {}) => ({
    ...getTableParams(tableState),
    groupByStage: 0,
    filterStage: isExcluded(data) ? undefined : data.stage,
    svodkaType: isExcluded(data) ? 'PplInStagePrjExcluded' : 'SWSHBasic',
});

export const getWorksheetListHandler = createTableHandler('worksheet', urls.WORKSHEET_LIST);
export const getWorksheetMassListHandler = createTableHandler('worksheetMass', urls.WORKSHEET_MASS_LIST, getWorksheetMassListParams);
export const getProjectListHandler = createTableHandler('project', urls.PROJECT_LIST);

const getProjectMassListParams = (tableState, { id }) => compose(
    assoc('userKey', id),
    assoc('svodkaType', 'MassRecrReport'),
    getTableParams
)(tableState);

export const getProjectMassListHandler = createTableHandler('projectMass', urls.PROJECT_MASS_LIST, getProjectMassListParams);

export const getApprovalPersonListHandler = createTableHandler('approvalPerson', urls.APPROVAL_PERSON_LIST);
export const getApprovalProjectListHandler = createTableHandler('approvalProject', urls.APPROVAL_PROJECT_LIST);

const getRequestParams = compose(
    ifElse(propEq('inwork', 1), assoc('unread', 1), assoc('unread', 0)),
    getTableParams,
);

export const getRequestListHandler = createTableHandler('request', urls.REQUEST_LIST, getRequestParams);

export const getNotdoneListHandler = createTableHandler('notdone', urls.NOTDONE_LIST, getTableParams);
